<template>
  <div class="dd-home">
    <div v-if="Object.keys(kbData).length > 0" class="kb-dd">
      <div class="title">- 课本点读 -</div>
      <div class="breder">
        <div v-for="(val, indexs) in kbData" :key="indexs" class="book-list">
          <div class="title-s"><img :src="icon[indexs]" />{{ val[0] }}</div>
          <div class="list">
            <Grid :cols="3" col-margin="0.64rem" row-margin="0.64rem">
              <GridItem v-for="(item, index) in val[1]" :key="index">
                <img
                  :src="$env.ossUrl(item.book.thumbCoverPath)"
                  class="book-cover"
                  @click="toBook(item.book.id)"
                />
              </GridItem>
            </Grid>
          </div>
        </div>
        <router-link :to="{ path: '/kbMore' }">
          <div class="more">查看更多课本点读</div>
        </router-link>
      </div>
    </div>
    <div v-if="mzData.length > 0" class="kb-dd">
      <div class="title">- 名著点读 -</div>
      <div class="breder">
        <div class="list-t">
          <Grid :cols="3" col-margin="0.64rem" row-margin="0.64rem">
            <GridItem v-for="(item, index) in mzData" :key="index">
              <img
                :src="$env.ossUrl(item.book.thumbCoverPath)"
                class="book-cover"
                @click="toBook(item.book.id)"
              />
            </GridItem>
          </Grid>
        </div>
        <router-link :to="{ path: '/hbMore', query: { type: 'mz' } }">
          <div class="more">查看更多名著点读</div>
        </router-link>
      </div>
    </div>
    <div v-if="hbData.length > 0" class="kb-dd">
      <div class="title">- 绘本点读 -</div>
      <div class="breder">
        <div class="list-t">
          <Grid :cols="3" col-margin="0.64rem" row-margin="0.64rem">
            <GridItem v-for="(item, index) in hbData" :key="index">
              <img
                :src="$env.ossUrl(item.book.thumbCoverPath)"
                class="book-cover"
                @click="toBook(item.bookId)"
              />
            </GridItem>
          </Grid>
        </div>
        <router-link :to="{ path: '/hbMore', query: { type: 'hb' } }">
          <div class="more">查看更多绘本点读</div>
        </router-link>
      </div>
    </div>
    <!-- 都没得数据的时候 -->
    <div
      v-if="hbData.length <= 0 && mzData.length <= 0 && Object.keys(kbData).length <= 0"
      class="no_data"
    >
      <img src="https://img.yzcdn.cn/upload_files/2020/09/10/FlHmJIcJSeT7o0b6XL8JyOvlWYc0.png" />
    </div>
  </div>
</template>

<script>
import Grid from '@/components/Grid'
import { kbDianDuList, hbMzDianDuList } from '@/api/diandu'
import { saveKey } from '@/static/js/zjs'
import { mapState } from 'vuex'
export default {
  name: 'Course',
  components: {
    Grid,
    GridItem: Grid.item
  },
  data() {
    return {
      hbData: [],
      kbData: [], // 课本点读的list
      mzData: [],
      icon: [
        'https://img.yzcdn.cn/upload_files/2020/08/24/Fgrxwbubw54MWYgiffbKVZPqaJCr.png',
        'https://img.yzcdn.cn/upload_files/2020/08/24/FgotNKsILLeQ86-g_UpQONidZvLu.png',
        'https://img.yzcdn.cn/upload_files/2020/08/24/Fvgb4EJeXzum3NuUe_8DOYP_B2g7.png'
      ]
    }
  },

  computed: {
    ...mapState('user', ['userPref']),
    grade() {
      return this.userPref.wbGrade
    }
  },
  watch: {
    grade: {
      handler(newVal, oldVal) {
        this.getList(newVal)
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
    this.testTongji()
  },
  methods: {
    getList(grade) {
      var selectedGrade = grade.substr(grade.length - 2, 1)
      var selectedTerm = grade.substr(grade.length - 1, 1)
      this.$http.get('/cms/upload/wbversion/version.json').then((ver) => {
        saveKey('verisonData', ver.data, 1)
        var slectedver = []
        ver.data.map((item) => {
          slectedver.push(item.id)
        })
        kbDianDuList(selectedGrade, selectedTerm, slectedver.join(',')).then((res) => {
          this.kbData = Object.entries(this.groupByVersion(res, ver.data)).slice(0, 3)

        })
        hbMzDianDuList('huibendiandu', selectedGrade, selectedTerm).then((res) => {
          this.hbData = res.slice(0, 6)

        })
        hbMzDianDuList('mingzhuyuedu', selectedGrade, selectedTerm).then((res) => {
          this.mzData = res.slice(0, 3)

        })
      })
    },

    // 根据版本分组
    groupByVersion(data = [], dit = []) {
      const obj = {}
      data.forEach((item) => {
        const ver = item.book.version
        const name = dit.find((i) => i.id === ver).wbVersion
        const x = obj[name] || []
        x.push(item)
        obj[name] = x
      })
      return obj
    },
    toBook(id) {
      this.$router.push({
        path: '/dianDuBooks',
        query: { id: id }
      })
    },
    testTongji() {
      const {
        openid,
        userInfo: { vipLevel, wbGrade, isRead, isCourse }
      } = this.$store
      window.Statistic.trackEvent({
        app: 'shanxiCms',
        source: 'mopa',
        openid: openid,
        category: '1',
        action: 'view',
        label: '点读',
        label1: '',
        vip: vipLevel || '',
        userGrade: wbGrade,
        userType: (isRead || '') + ':' + (isCourse || '')
      })
    }
  }
}
</script>

<style lang="scss">
.dd-home {
  .no_data {
    background: #fff;
    margin-top: 7px;
    display: flex;
    justify-content: center;
    height: calc(100vh - 73px);
    img {
      width: 168px;
      height: 196px;
      margin-top: 70px;
    }
  }
  .kb-dd {
    .breder {
      border-radius: 18px 18px 0px 0px;
      padding-bottom: 33px;
      background: #ffffff;
      .more {
        border: 1px solid rgba(255, 54, 71, 0.5);
        box-sizing: border-box;
        border-radius: 8px;
        height: 49px;
        font-weight: normal;
        font-size: 17px;
        line-height: 49px;
        color: #ff3647;
        text-align: center;
        width: 337px;
        margin: 0 auto;
        margin-top: 39px;
      }
      .list-t {
        padding: 20px 19px 0;
      }
      .book-list {
        padding: 23px 19px 0px;
        .list {
          margin-top: 9px;
        }

        .title-s {
          display: flex;
          align-items: center;
          font-weight: 500;
          font-size: 18px;
          img {
            width: 23px;
            margin-right: 7px;
          }
        }
      }
    }
    .title {
      height: 58.5px;
      font-weight: 500;
      font-size: 18px;
      text-align: center;
      line-height: 58.5px;
    }
    .book-cover {
      width: 98px;
      height: 133px;
    }
  }
}
</style>
